/**
 * @typedef {Record<string, string>} Headers
 */

/**
 * @callback HeadersCallback
 * @return {Record<string, string>} Record
 */

/**
 * @readonly
 * @enum {string}
 */
export const fetchMethod = Object.freeze({
  GET: 'get',
  POST: 'post',
  PATCH: 'patch',
  PUT: 'put',
  DELETE: 'delete',
});
